import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-0.25 -0.25 24.5 24.5",
	fill: "none",
	strokeWidth: 1.5,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 23.5H0.5V16.5H8V17.5C8 18.6 8.9 19.5 10 19.5H14.5C15.6 19.5 16.5 18.6 16.5 17.5V16.5H23.5V23.5Z",
			fill: "#DAD9EF",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 16.5L4 10.5H6.5",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 16.5L4 10.5H6.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 10.5H20L23.5 16.5",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 10.5H20L23.5 16.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 11.5V0.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 7.5L11.5 11.5L7.5 7.5",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 7.5L11.5 11.5L7.5 7.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInbox;
